import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ContactComponent } from './contact/contact.component';
import { BuyPropertiesComponent } from './buy-properties/buy-properties.component';
import { RentPropertiesComponent } from './rent-properties/rent-properties.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { WhyComponent } from './why/why.component';
import { ServicesComponent } from './services/services.component';
import { DevelopersComponent } from './developers/developers.component';
import { AboutComponent } from './about/about.component';
import { CareerComponent } from './career/career.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { ApiService } from './api.services';
import { PropertyDetailComponent } from './property-detail/property-detail.component';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule, NgxUiLoaderRouterModule } from "ngx-ui-loader";
import { FormsModule } from '@angular/forms';
import { BlogsComponent } from './blogs/blogs.component';
import { BlogDetailsComponent } from './blog-details/blog-details.component';
import { CampaignComponent } from './campaign/campaign.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#000000',
  pbColor: '#000000',
  fastFadeOut: true,
};

import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ContactComponent,
    BuyPropertiesComponent,
    PropertyDetailComponent,
    RentPropertiesComponent,
    PrivacyComponent,
    WhyComponent,
    ServicesComponent,
    DevelopersComponent,
    AboutComponent,
    CareerComponent,
    TermsConditionComponent,
    BlogsComponent,
    BlogDetailsComponent,
    CampaignComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    MatDialogModule,
    AppRoutingModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true, exclude: [],
      excludeRegexp: [
        ".*\\/widget\\/value\\?widgetId=.*"
      ]
    }
    ),
  ],
  providers: [
    ApiService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
